<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vii"><strong>Contents</strong></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/html/9780226695761_07_ack#ack">Acknowledgments</a></p>
<p class="toca"><a href="#/html/9780226695761_08_int#int"><strong>Introduction</strong></a></p>
<p class="tocb">Ina Ganguli, Shulamit Kahn, and Megan MacGarvie</p>
<p class="toc"><a href="#/html/9780226695761_09_pt1#ptI">I. LOCATION CHOICES OF INTERNATIONAL STUDENTS AND RETURN MIGRATION</a></p>
<p class="toca"><a href="#/html/9780226695761_10_ch1#ch1"><strong>1. Return Migrants’ Self-Selection: Evidence for Indian Inventors</strong></a></p>
<p class="toc">Stefano Breschi, Francesco Lissoni, and Ernest Miguelez</p>
<p class="toca"><span href="#/html/9780226695761_11_ch2#ch2" title="Link target outside of Sample"><strong>2. Will the US Keep the Best and the Brightest (as Postdocs)? Career and Location Preferences of Foreign STEM PhDs</strong></span></p>
<p class="tocb">Ina Ganguli and Patrick Gaulé</p>
<p class="toc"><span href="#/html/9780226695761_12_pt2#ptII" title="Link target outside of Sample">II. IMMIGRATION POLICY AND INNOVATION</span></p>
<p class="toca"><span href="#/html/9780226695761_13_ch3#ch3" title="Link target outside of Sample"><strong>3. High-Skill Immigration, Innovation, and Creative Destruction</strong></span></p>
<p class="toc">Gaurav Khanna and Munseob Lee</p>
<p class="toca"><span href="#/html/9780226695761_14_ch4#ch4" title="Link target outside of Sample"><strong>4. New Data and Facts on H-1B Workers across Firms</strong></span></p>
<p class="toc">Anna Maria Mayda, Francesc Ortega, Giovanni Peri, Kevin Shih, and Chad Sparber</p>
<p class="toca"><a id="page_viii"></a><span href="#/html/9780226695761_15_ch5#ch5" title="Link target outside of Sample"><strong>5. Immigration and Invention: Does Language Matter?</strong></span></p>
<p class="tocb">Kirk Doran and Chungeun Yoon</p>
<p class="toc"><span href="#/html/9780226695761_16_pt3#ptIII" title="Link target outside of Sample">III. IMMIGRATION AND ENTREPRENEURSHIP</span></p>
<p class="toca"><span href="#/html/9780226695761_17_ch6#ch6" title="Link target outside of Sample"><strong>6. Immigrant Entrepreneurs and Innovation in the US High-Tech Sector</strong></span></p>
<p class="toc">J. David Brown, John S. Earle, Mee Jung Kim, and Kyung Min Lee</p>
<p class="toca"><span href="#/html/9780226695761_18_ch7#ch7" title="Link target outside of Sample"><strong>7. Immigrant Networking and Collaboration: Survey Evidence from CIC</strong></span></p>
<p class="toc">Sari Pekkala Kerr and William R. Kerr</p>
<p class="toca"><span href="#/html/9780226695761_19_ch8#ch8" title="Link target outside of Sample"><strong>8. Are Foreign STEM PhDs More Entrepreneurial? Entrepreneurial Characteristics, Preferences, and Employment Outcomes of Native and Foreign Science and Engineering PhD Students</strong></span></p>
<p class="tocb">Michael Roach, Henry Sauermann, and John Skrentny</p>
<p class="toc"><span href="#/html/9780226695761_20_not#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/html/9780226695761_21_con#con" title="Link target outside of Sample">Contributors</span></p>
<p class="toc"><span href="#/html/9780226695761_22_ind#ind" title="Link target outside of Sample">Author Index</span></p>
<p class="toc"><span href="#/html/9780226695761_23_ind1#ind1" title="Link target outside of Sample">Subject Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226695761_06_toc.vue?19f456ee